import { atom } from 'recoil';

export const TimeDurationState = atom({
    key: 'TimeDurationState', 
    default: null, 
});